// FULL FIXED cart script - vanilla JS (drop-in replacement)
// Disabled when Oxify Cart is active — see layout/theme.liquid inline script
(function () {
  "use strict";

  if (window.__OXIFY_CART_ACTIVE__) {
    return;
  }

  // --- Helpers ---
  function $(sel) {
    return document.querySelector(sel);
  }
  function $$(sel) {
    return Array.from(document.querySelectorAll(sel));
  }
  function on(root, event, selector, handler) {
    root.addEventListener(event, function (e) {
      const target = e.target.closest(selector);
      if (target && root.contains(target)) handler.call(target, e);
    });
  }

  // Shopify locale/currency (safe guard if Shopify object missing)
  let shopifyLocale =
    window.Shopify && Shopify.locale ? Shopify.locale.split("-")[0] : "en";
  let localeCountry = `${shopifyLocale}-${
    (window.Shopify && Shopify.country) || "US"
  }`;
  const shopCurrency =
    (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";

  function currencyES6Format(money) {
    try {
      const formatted = new Intl.NumberFormat(localeCountry, {
        style: "currency",
        currency: shopCurrency,
      }).format(Number(money));
      return formatted.replace(/(\D)(\d)/, "$1 $2");
    } catch (err) {
      // fallback
      return Number(money).toFixed(2);
    }
  }

  // --- state to prevent double requests ---
  const pendingKeys = new Set();
  let globalUpdating = false;

  // --- API helpers ---
  async function getCartData() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  }

  async function changeCartQuantity(id, quantity) {
    // id is expected to be line key (the key you set in data-line-key)
    // quantity is a number (final quantity)
    const body = JSON.stringify({ id: String(id), quantity: Number(quantity) });
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw err;
    }
    return res.json();
  }

  // --- UI helpers: loader + disable UI for a specific line key ---
  function showLoader() {
    const loader = $(".custom-cart-loader");
    if (loader)
      (loader.classList.add("loader"), (loader.style.display = "block"));
  }
  function hideLoader() {
    const loader = $(".custom-cart-loader");
    if (loader)
      (loader.classList.remove("loader"), (loader.style.display = "none"));
  }

  function disableLineUI(lineKey) {
    if (!lineKey) return;
    pendingKeys.add(lineKey);
    $$(`[data-line-key="${lineKey}"]`).forEach((el) =>
      el.setAttribute("data-pending", "true"),
    );
  }
  function enableLineUI(lineKey) {
    if (!lineKey) return;
    pendingKeys.delete(lineKey);
    $$(`[data-line-key="${lineKey}"]`).forEach((el) =>
      el.removeAttribute("data-pending"),
    );
  }

  // --- RENDER CART DRAWER (rebuild items in #productbox) ---
  async function renderCartDrawer() {
    try {
      // showLoader();
      const data = await getCartData();

      // update header counts + totals
      const productbox = $("#productbox");
      if (!productbox) return;

      // clear and rebuild
      productbox.innerHTML = "";

      // update counts
      const itemCount = data.item_count || 0;
      const totalPrice = (data.total_price || 0) / 100;

      const cartItemCount = $("#cart_item_count");
      if (cartItemCount)
        cartItemCount.textContent =
          itemCount +
          (itemCount === 1 ? " Item in your cart" : " Items in your cart");

      const miniCartTotal = $("#mini_cart_total");
      if (miniCartTotal)
        miniCartTotal.textContent = currencyES6Format(totalPrice.toFixed(2));

      $$(".custom_cart_count").forEach((el) => (el.textContent = itemCount));

      if (itemCount === 0) {
        productbox.innerHTML = `
          <div class="cart-item-container">
            <div class="media-body empty-media">
              <figure>
                <img src="https://cdn.shopify.com/s/files/1/0832/8521/3505/files/empty-cart.webp?v=1698652243" alt="empty-cart" loading="lazy">
              </figure>
              <h3 class="row mini-cart-product">Your cart is empty.</h3>
            </div>
            <div class="bottom-cart-box">
              <div class="cart-btn-container">
                <a href="/collections/all" class="primary-btn cont-shopping sd_shopproduct" style="display:block;">Continue Shopping</a>
              </div>
            </div>
          </div>
        `;
        hideLoader();
        updateOrderSummaryUI(data); // still update summary to zero
        updateStickyFooterUI(data);
        return;
      }

      // build each item using the same structure you used originally
      data.items.forEach((item, i) => {
        const itemId = item.id;
        const title = item.product_title;
        const url = item.url || "javascript:void(0);";
        const qty = item.quantity;
        const price = (item.price || 0) / 100;
        const original = (item.original_price || item.price || 0) / 100;
        const image = item.image || "";
        const variantTitle = item.variant_title || "";
        const productKey = item.key; // this is the line key Shopify returns

        // template closely matches your previous template
        const div = document.createElement("div");
        div.className = "product-inner row mini-cart-product";
        div.setAttribute("data-key", itemId);
        div.setAttribute("data-line-key", productKey);
        div.innerHTML = `
          <div class="product_image image">
            <a href="${url}">
              <img src="${image}" alt="${title}">
            </a>
          </div>
          <div class="pro-content">
            <div class="cartproname prohead">
              <a href="${url}" id="product_head">${title}</a>
              <div class="prd_variant_style">${variantTitle}</div>
            </div>
            <div class="price-section">
        <span class="price product_price">${currencyES6Format(
          (price * qty).toFixed(2),
        )}</span>
        ${
          original > price
            ? `<span class="compare-price" style="text-decoration: line-through; color:#888; margin-left:6px;">${currencyES6Format(
                (original * qty).toFixed(2),
              )}</span>`
            : ""
        }
      </div>

            <div class="pro-quantity">
              <div class="quantity-selector">
                <div class="quantitybox">
                  <button type="button" class="sd_altera sminus" aria-label="Decrease quantity" data-line-key="${productKey}">-</button>
                  <input type="text" readonly class="qty-input" value="${qty}" data-line-key="${productKey}">
                  <button type="button" class="sd_altera splus" aria-label="Increase quantity" data-line-key="${productKey}">+</button>
                </div>
              </div>
            </div>
          </div>
          <div class="remove-section">
            <p class="removeproduct remove" data-line-key="${productKey}" aria-label="Remove item">
              <!-- Keep your SVG icon -->
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.33301 4.66663H3.88856H16.333" stroke="#494949" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14.7776 4.66665V15.5555C14.7776 15.9681 14.6137 16.3638 14.3219 16.6555C14.0302 16.9472 13.6346 17.1111 13.222 17.1111H5.44423C5.03167 17.1111 4.63601 16.9472 4.34428 16.6555C4.05256 16.3638 3.88867 15.9681 3.88867 15.5555V4.66665M6.22201 4.66665V3.1111C6.22201 2.69854 6.38589 2.30288 6.67762 2.01115C6.96934 1.71943 7.365 1.55554 7.77756 1.55554H10.8887C11.3012 1.55554 11.6969 1.71943 11.9886 2.01115C12.2803 2.30288 12.4442 2.69854 12.4442 3.1111V4.66665" stroke="#494949" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.77734 8.55554V13.2222" stroke="#494949" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.8887 8.55554V13.2222" stroke="#494949" stroke-width="1.55556" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </p>
          </div>
        `;
        productbox.appendChild(div);
      });

      // update order summary & sticky footer
      updateOrderSummaryUI(data);
      updateStickyFooterUI(data);
    } catch (err) {
      console.error("renderCartDrawer error", err);
    } finally {
      hideLoader();
    }
  }

  // --- Update order summary UI (IDs from your markup) ---
  function updateOrderSummaryUI(data) {
    try {
      let totalMRP = 0;
      let totalPrice = 0;

      (data.items || []).forEach((item) => {
        totalMRP +=
          ((item.original_price || item.price || 0) / 100) * item.quantity;
        totalPrice += ((item.price || 0) / 100) * item.quantity;
      });

      const discount = totalMRP - totalPrice;
      const delivery = totalPrice > 799 ? 0 : 49;
      const payable = totalPrice + delivery;

      const setText = (sel, txt) => {
        const el = $(sel);
        if (el) el.textContent = txt;
      };
      setText("#os_total_mrp", currencyES6Format(totalMRP.toFixed(2)));
      setText("#os_discount", "-" + currencyES6Format(discount.toFixed(2)));
      setText("#os_delivery", currencyES6Format(delivery.toFixed(2)));
      setText("#os_payable", currencyES6Format(payable.toFixed(2)));
      setText("#summary_total_amount", currencyES6Format(payable.toFixed(2)));
      setText("#savings_amount", currencyES6Format(discount.toFixed(2)));

      const savedMsg = $(".savings-message");
      if (savedMsg) savedMsg.style.display = discount > 0 ? "" : "none";
    } catch (err) {
      console.warn("updateOrderSummaryUI error", err);
    }
  }

  // --- Sticky footer update ---
  function updateStickyFooterUI(data) {
    try {
      let totalMRP = 0,
        totalPrice = 0;
      (data.items || []).forEach((item) => {
        totalMRP +=
          ((item.original_price || item.price || 0) / 100) * item.quantity;
        totalPrice += ((item.price || 0) / 100) * item.quantity;
      });
      const setText = (sel, txt) => {
        const el = $(sel);
        if (el) el.textContent = txt;
      };
      if ($("#sticky_price"))
        setText("#sticky_price", Number(totalPrice).toFixed(2));
      if ($("#sticky_mrp_value"))
        setText("#sticky_mrp_value", Number(totalMRP).toFixed(2));
    } catch (err) {
      console.warn("updateStickyFooterUI error", err);
    }
  }

  // --- Delegated event handlers (single binding) ---
  // Note: we always use data-line-key to identify the line in Shopify

  // Increase quantity
  on(document, "click", ".splus", async function (e) {
    e.preventDefault();
    if (this.getAttribute("data-pending")) return; // if updating skip
    const lineKey =
      this.getAttribute("data-line-key") ||
      this.closest("[data-line-key]")?.getAttribute("data-line-key");
    if (!lineKey) return;

    const input = this.closest(".quantitybox")?.querySelector(".qty-input");
    const current = Number(input ? input.value : 0) || 0;
    const next = current + 1;

    try {
      disableLineUI(lineKey);
      // showLoader();
      await changeCartQuantity(lineKey, next);
      await renderCartDrawer(); // re-render with latest data
    } catch (err) {
      console.error("increase error", err);
    } finally {
      enableLineUI(lineKey);
      hideLoader();
    }
  });

  // Decrease quantity
  on(document, "click", ".sminus", async function (e) {
    e.preventDefault();
    if (this.getAttribute("data-pending")) return;
    const lineKey =
      this.getAttribute("data-line-key") ||
      this.closest("[data-line-key]")?.getAttribute("data-line-key");
    if (!lineKey) return;

    const input = this.closest(".quantitybox")?.querySelector(".qty-input");
    const current = Number(input ? input.value : 0) || 0;
    const next = Math.max(1, current - 1);

    try {
      disableLineUI(lineKey);
      // showLoader();
      await changeCartQuantity(lineKey, next);
      await renderCartDrawer();
    } catch (err) {
      console.error("decrease error", err);
    } finally {
      enableLineUI(lineKey);
      hideLoader();
    }
  });

  // Remove item
  on(document, "click", ".removeproduct", async function (e) {
    e.preventDefault();
    // closest ensures clicks on SVG inside still map to whole element
    const lineKey = this.getAttribute("data-line-key") || this.id;
    if (!lineKey) return;

    // Visual feedback: fade
    const productInner = this.closest(".product-inner");
    if (productInner) {
      productInner.style.opacity = "0.5";
      productInner.style.pointerEvents = "none";
    }

    try {
      disableLineUI(lineKey);
      // showLoader();
      await changeCartQuantity(lineKey, 0);
      await renderCartDrawer();
    } catch (err) {
      console.error("remove error", err);
    } finally {
      enableLineUI(lineKey);
      hideLoader();
    }
  });

  // Add to cart (delegated for .addToCart)
  on(document, "click", ".addToCart", async function (e) {
    e.preventDefault();
    const variantId =
      this.getAttribute("data-variant-id") || this.dataset.variantId;
    if (!variantId) return;

    try {
      showLoader();
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ id: String(variantId), quantity: 1 }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw err;
      }
      updateCartDrawerButton();
      // open drawer and render
      const cartDrawer = $("#cart_drawer");
      if (cartDrawer) cartDrawer.classList.add("active");
      // document.documentElement.style.overflow = "hidden";
      // document.body.style.overflow = "hidden";
      await renderCartDrawer();
    } catch (err) {
      console.error("addToCart error", err);
    } finally {
      hideLoader();
    }
  });

  // Open drawer buttons
  on(
    document,
    "click",
    ".site-header-cart--button, .icons-list-item-block, [data-cart-drawer]",
    function (e) {
      e.preventDefault();
      const cartDrawer = $("#cart_drawer");
      if (cartDrawer) cartDrawer.classList.add("active");
      // document.documentElement.style.overflow = "hidden";
      // document.body.style.overflow = "hidden";
      renderCartDrawer();
    },
  );

  // Close drawer
  on(document, "click", ".sides_cross_image, .drawer-close-btn", function (e) {
    const cartDrawer = $("#cart_drawer");
    if (cartDrawer) cartDrawer.classList.remove("active");
    document.documentElement.style.overflow = "visible";
    document.body.style.overflow = "visible";
  });

  // Sticky proceed button
  on(document, "click", "#sticky_proceed_btn", function (e) {
    window.location.href = "/checkout";
  });

  // init
  async function init() {
    try {
      // initial render
      await renderCartDrawer();
      // update header small count
      const data = await getCartData();
      $$(".custom_cart_count").forEach(
        (el) => (el.textContent = data.item_count || 0),
      );
    } catch (err) {
      console.warn("init cart error", err);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
